export const formatDateTimeToLocal = (dateTime: string) => {
  // Pure date, no time component — parse as local, not UTC
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateTime)) {
    const [year, month, day] = dateTime.split("-").map(Number);
    const localDate = new Date(year, month - 1, day);
    const date = localDate.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    return { date, time: "" }; // no meaningful time for a date-only value
  }

  const utcString = dateTime.endsWith("Z") ? dateTime : `${dateTime}Z`;
  const localDate = new Date(utcString);

  const date = localDate.toLocaleDateString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  const time = localDate.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
  });

  return { date, time };
};

export const getCurrentDateTime = (dateOnly: boolean = false) => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hour = String(now.getHours()).padStart(2, "0");
  const minute = String(now.getMinutes()).padStart(2, "0");
  const second = String(now.getSeconds()).padStart(2, "0");

  return dateOnly ? `${year}${month}${day}` : `${year}${month}${day}${hour}${minute}${second}`;
};
